import moment, { Moment } from "moment";
import {
    formatAssetInfoTradingHours
} from "./formatAssetInfoTradingHours";
import {
    IWeekDayTradingHours,
} from "../../LiteTrade/types/liteTradeReducer.t";
import getStartDateOfBiddingForWeek from "./getStartDateOfBiddingForWeek";


export const getTimeBeforeBidding = (tradingHours:  IWeekDayTradingHours[] = [], today: Moment = moment()): number => {
    const weekSchedule = formatAssetInfoTradingHours(tradingHours);
    const startDateOfBidding = getStartDateOfBiddingForWeek(weekSchedule, today);
    return startDateOfBidding.valueOf() - today.valueOf(); 
}

export default getTimeBeforeBidding;
